import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';

import { showResult } from '../utils';
import { apiUrlGenerator } from '../use-api';

import type {
  IPartialPaginationMeta,
  ICorePatientsResponse,
} from 'infrastructure/interfaces';

const url = 'core/patients';
export const CORE_PATIENTS_PER_PAGE = 100;

export type TQueryProps = {
  page?: number;
  childClinic?: boolean;
  clinicGuid?: string;
  patientGuid?: string;
  doctorGuid?: string;
  pcmStatus?: boolean;
  ccmStatus?: string;
  clinicsStatus?: string;
  status?: string;
  guid?: string;
};

type TFilterData = TQueryProps & IPartialPaginationMeta;

const queryFn = async (filter: TFilterData) => {
  const { data, error } = await dataService.getList<ICorePatientsResponse>(
    apiUrlGenerator(url, filter),
  );

  if (error) {
    return Promise.reject(error);
  }
  return data;
};

const getCorePatientsKey = (filter: TFilterData) => ['getCorePatients', filter];

export const useGetCorePatients = (props: TQueryProps) => {
  const filter: TFilterData = {
    ...props,
    items: CORE_PATIENTS_PER_PAGE,
  };

  const { data, error, isLoading, isFetching } = useQuery<
    ICorePatientsResponse | undefined,
    string | undefined
  >({
    queryKey: getCorePatientsKey(filter),
    queryFn: async () => queryFn(filter),
    keepPreviousData: true,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { data, isLoading, isFetching };
};
